import type { TiptapDoc } from '@odo/shared-ui';
import type { CommunicationChannel } from '../../../../services/communications';
import { insertAllSeedSections, insertSeedSection, seedSectionsFor } from './bodySeedSections';

interface BodySeedChipsProps {
    doc: TiptapDoc;
    channel: CommunicationChannel;
    onInsert: (doc: TiptapDoc) => void;
    disabled: boolean;
}

// Every channel today offers either two or three sections - "All two"/"All
// three" both read naturally; nothing else is worth a number word for.
const ALL_LABEL_BY_COUNT: Record<number, string> = { 2: 'All two', 3: 'All three' };

// Pinned row under the editor's toolbar; sections are per-channel and
// repeat clicks are safe (bodySeedSections' heading guard).
export function BodySeedChips({ doc, channel, onInsert, disabled }: BodySeedChipsProps) {
    const sections = seedSectionsFor(channel);
    const allLabel = ALL_LABEL_BY_COUNT[sections.length] ?? 'Insert all';

    return (
        <div className="shrink-0 flex items-center gap-1 px-2 py-1 border-b border-gray-100 bg-gray-50/60 overflow-x-auto">
            {sections.map((section) => (
                <button
                    key={section.id}
                    type="button"
                    title={section.heading}
                    disabled={disabled}
                    onClick={() => onInsert(insertSeedSection(doc, section.heading))}
                    className="shrink-0 text-[11px] font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100 rounded-full px-2 h-6 whitespace-nowrap transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    + {section.heading}
                </button>
            ))}
            <button
                type="button"
                title={`Insert ${sections.length === 1 ? 'the' : 'all'} section${sections.length === 1 ? '' : 's'}`}
                disabled={disabled}
                onClick={() => onInsert(insertAllSeedSections(doc, channel))}
                className="shrink-0 text-[11px] font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100 rounded-full px-2 h-6 whitespace-nowrap transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
                {allLabel}
            </button>
        </div>
    );
}
